
export class ModuleIdRequest {
    moduleId: number;
    username?: string;

    constructor(moduleId: number, username?: string) {
        this.moduleId = moduleId;
        this.username = username;
    }
}